import React from "react";
import SectionHeading from "./sectionHeading";
import FeatureList from "./featureList";
import { useMediaQuery } from "react-responsive";
import { LazyLoadImage } from "react-lazy-load-image-component";

const MobileAppShowcase = ({ content }) => {
  const { title, subtitle, image, numbered, isShowButtonDownload } = content;
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const displayImage = content.displayImgMobile || !isMobile;

  return (
    <div className="mobileAppShowcase">
      <div className="main">
        {displayImage && (
          <div className="right">
            <LazyLoadImage src={image?.url || image} alt="Speedoc benefits" effect="blur" />
          </div>
        )}
        <div className="left">
          <SectionHeading title={title} subtitle={subtitle} className="sectionHeading" />
          <FeatureList {...content} numbered={numbered} isShowButtonDownload={isShowButtonDownload} />
        </div>
      </div>
    </div>
  );
};

export default MobileAppShowcase;
